import React, { useEffect, useState,useRef } from "react";
import axios from "../../../plugins/axios";
import _ from 'lodash';
import { useTranslation } from "react-i18next"
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { monitorState,wardState,globalConnectedDeviceState, deviceModelInfo  } from '../../../plugins/recoil';
import { useRecoilState } from 'recoil';
import { pad } from '../../../plugins/common'
import { ReactComponent as IconArrowUp } from "../../../assets/icons/ic-arrow-up.svg";
import { ReactComponent as IconArrowDown } from "../../../assets/icons/ic-arrow-down.svg";
import { ReactComponent as IconCheckBlue } from "../../../assets/icons/ic-check_blue.svg";
import { ReactComponent as IconCheck } from "../../../assets/icons/ic-check.svg";
import { ReactComponent as IconConnected } from "../../../assets/icons/ic_plug_on.svg";
import { ReactComponent as IconDisConnected } from "../../../assets/icons/ic_plug_off.svg";


import Toast from "../../../plugins/useToast";

const initialPatientInfo = {
  displayDevicePatientId: true,
  devicePatientId: '',
  displayName: true,
  name: '',
  birthDate: '',
  gender: '',
  category: 'ADULT',
  height: '',
  weight: '',
  phoneNumber: '',
  address: '',
  protectorName: '',
  protectorPhoneNumber: '',
  room: '',
  doctor1: {
    doctorName: '',
    doctorPhoneNumber: ''
  },
  doctor2: {
    doctorName: '',
    doctorPhoneNumber: ''
  },
  nurse1: {
    nurseName: '',
    nursePhoneNumber: ''
  },
  nurse2: {
    nurseName: '',
    nursePhoneNumber: ''
  },
  nurse3: {
    nurseName: '',
    nursePhoneNumber: ''
  }
};

const PatientInfoSettings = ({ wardSettings, handleSaveParameter,handleConfirm}) => {
    const { t } = useTranslation()
    const isFirstRender = useRef(true);
    const [curWard,] = useRecoilState(wardState)
    const [curMonitor,] = useRecoilState(monitorState)
    const [globalConnectedDevice,] = useRecoilState(globalConnectedDeviceState);
    const [dashboard, setDashBoard] = useState()
    const [originalPatients, setOriginalPatients] = useState([]); // 원본 알람 설정 살태
    const [changeOriginalPatients, setChangeOriginalPatients] = useState([]); // 변경된 알람 설정 상태   
    const [isDisabled, setIsDisabled] = useState(true); //저장버튼
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);     
    const [tempPatientId, setTempPatientId] = useState('') //Focus 될 떄 저장 하고, Blue할 때 초기화
    const [deviceModelMenus, ] = useRecoilState(deviceModelInfo);      
    
    const thClasses = "px-2 py-2 !font-light border-r border-[#444444]";
    const tdClasses = "h-[30px] border-r border-[#444444] !font-light";    

    // ✅ Patient List 조회
    const setPatientList = async () => {
        try{               
            const devices = Array.isArray(dashboard?.devices) ? dashboard.devices.map(device => device.deviceId) : [];

            if(devices.length == 0){
                return false;
            }            
            
            const patientRes = await axios.get(`/patients`,{params : {wardId : curWard.value,deviceIds : devices.join(',')}});              
            if( patientRes.code !== 200) throw patientRes;            

            // 환자 데이터 + 연결된 Device 정보 병합            
            const mergeData = mergePatientsData(dashboard?.devices, patientRes.data.patients);        
            console.log('mergeData : ', mergeData);    

            //혹시 몰라서 일단 2개로 세팅해둠.
            setOriginalPatients(mergeData);
            setChangeOriginalPatients(mergeData);
        }
        catch(error) {
            console.error(error);
            Toast({ isSuccess: false, msg: error });
        }
    }        

    // ✅ Toogle 드롭다운 이벤트
    const toggleDropdown = (index) => {
        setOpenDropdownIndex((prevIndex) => (prevIndex === index ? null : index));
    };
        
    // ✅ Device 데이터 기준으로 환자 데이터 병합 함수
    const mergePatientsData = (devices, patients) => {
        const sortedDevices = [...devices].sort((a, b) => a.displayOrder - b.displayOrder);        
        return sortedDevices.map(device => {
            const matchedPatient = patients.find(patient => patient.id === device.patientId);
            if (!matchedPatient) {
                return {
                    ...device,                    
                    status: 'UNASSIGNED',
                    name : '',
                    devicePatientId : '',
                    gender : 'M',
                    birthDate : null,                                    
                }
            }
            return {
                ...matchedPatient,
                deviceId : device.deviceId,
                bedNumber: device.bedNumber,
                type: device.type,
                deviceModel: device.deviceModel,
            };
        })
    };

    // ✅ Device 데이터 기준으로 환자 데이터 병합 함수
    // const mergePatientsData = (devices, patients) => {
    //     console.log('=== mergePatientsData 시작 ===');
    //     console.log('📦 전체 devices:', devices);
    //     console.log('👥 전체 patients:', patients);
    //     console.log('devices 개수:', devices?.length);
    //     console.log('patients 개수:', patients?.length);
        
    //     const sortedDevices = [...devices].sort((a, b) => a.displayOrder - b.displayOrder);
        
    //     return sortedDevices.map((device, index) => {
    //         console.log(`\n--- Device ${index + 1} 처리 중 ---`);
    //         console.log('🔍 현재 device:', device);
    //         console.log('  deviceId:', device.deviceId);
    //         console.log('  patientId:', device.patientId);
            
    //         const matchedPatient = patients.find(patient => patient.id === device.patientId);
            
    //         if (!matchedPatient) {
    //             console.log('❌ 매칭 실패!');
    //             console.log('  찾으려는 patientId:', device.patientId);
    //             console.log('  patients 배열의 모든 id:', patients.map(p => p.id));
    //             console.log('  타입 확인 - device.patientId:', typeof device.patientId, device.patientId);
    //             console.log('  타입 확인 - patients[0]?.id:', typeof patients[0]?.id, patients[0]?.id);
                
    //             return {
    //                 ...device,                    
    //                 status: 'UNASSIGNED',
    //                 name : '',
    //                 devicePatientId : '',
    //                 gender : 'M',
    //                 birthDate : null,                                    
    //             }
    //         }
            
    //         console.log('✅ 매칭 성공!');
    //         console.log('  매칭된 patient:', matchedPatient);
            
    //         return {
    //             ...matchedPatient,
    //             deviceId : device.deviceId,
    //             bedNumber: device.bedNumber,
    //             type: device.type,
    //             deviceModel: device.deviceModel,
    //         };
    //     });
    // };

    // ✅ Device 데이터 admit / discharge 상태 변경 함수
    const setAdmittedStatus = (deviceId,type,patientInfo) => {

        const device = dashboard?.devices?.find(d => d.deviceId === deviceId);
        if (!device) return;

        //  ✅ dashboard.devices의 patientId도 변경 (맵핑을 위해서 넣어줘야 됨.)
        setDashBoard(prev => {
            if (!prev) return prev;
            return {
                ...prev,
                devices: prev.devices.map(d =>
                    d.deviceId === deviceId
                        ? { ...d, patientId: type == 'admit' ? patientInfo.id : null } //admit인 경우에는 patientInfo의 id를 넣고, discharge인 경우에는 null을 넣기
                        : d
                ),
            };
        });

        let data;

        // ✅ 변경된 환자 데이터 생성 (admit / discharge에 따라 다름)
        if(type == 'admit'){   
            // 새로운 환자 데이터 생성
            data = {
                ...patientInfo,
                deviceId: device.deviceId,
                bedNumber: device.bedNumber,
                type: device.type,
            };
        }
        else if(type == 'discharge'){
            data = {
                ...device,                    
                status: 'UNASSIGNED',
                name : '',
                devicePatientId : '',
                gender : 'M',
                birthDate : null,                    
            }            
        }    

        // 두 배열 모두 deviceId 기준으로 데이터만 교체 (순서 유지)
        setOriginalPatients(prev =>
            prev.map(row => row.deviceId === deviceId ? { ...row, ...data } : row)
        );
        setChangeOriginalPatients(prev =>
            prev.map(row => row.deviceId === deviceId ? { ...row, ...data } : row)
        );
    }

    // ✅ 공통 Value 변경 함수
    const handleChangeValue = (deviceId,parameter,value) => {        
        const updatedPatients = changeOriginalPatients.map((patient, index) => {            
            const matchedDevice = patient.deviceId === deviceId; // Device ID로 매칭
            if (matchedDevice) {
                return { ...patient, [parameter]: value };
            }
            return patient;
        });
        setChangeOriginalPatients(updatedPatients);
    }    

    // ✅ Admit Confirm Open 버튼 클릭 이벤트    
    const handleAdmitConfirm = (deviceId) => {        
        handleConfirm('Admit',t('setting.admitConfirm'),() => handleConfirmYes(deviceId,'_','admit'),handleConfirmCancel('admit'));
    }

    // ✅ Discharge Confirm Open 버튼 클릭 이벤트
    const handleDischargeConfirm = (deviceId,patientId,name) => {        
        handleConfirm('Discharge',t('setting.dischargeConfirm', { name: name }),() => handleConfirmYes(deviceId,patientId,'discharge'),() => handleConfirmCancel(deviceId,'discharge'));        
    }

    // ✅ Admit Confirm Yes 버튼 클릭 이벤트    
    const handleConfirmYes = (deviceId,patientId,type) => {
        type == 'admit' && handleAdmit(deviceId);
        type == 'discharge' && handleDischarge(deviceId,patientId);
    }    

    // ✅ Confirm No 버튼 클릭 이벤트    
    const handleConfirmCancel = (deviceId,type) => {
        if(type == 'discharge'){
            setChangeOriginalPatients(prev =>
                prev.map(row =>
                    row.deviceId === deviceId
                        ? { ...row, devicePatientId: tempPatientId }
                        : row
                )
            );
            setTempPatientId('');
        }        
    }

    // ✅ Admit 버튼 클릭 이벤트
    const handleAdmit = async (deviceId) => {
        try{
            const deviceInfo = changeOriginalPatients.find(patient => patient.deviceId === deviceId);
            const payload = cloneDeep(initialPatientInfo);
            payload.name = deviceInfo.name ? deviceInfo.name : 'Unknown';
            payload.devicePatientId = deviceInfo.devicePatientId ? deviceInfo.devicePatientId : `PI_${moment().format('YYMMDDHHmmss')}`;
            payload.gender = deviceInfo.gender;
            payload.birthDate = deviceInfo.birthDate;
            payload.deviceId = deviceId;            

            const res =  await axios.post('/patient', payload);
            if (res.code != '200') throw res 
            
            setAdmittedStatus(deviceId,'admit',res.data);
            handleSaveParameter(); //Dashboard에 화면 설정 보여주기 위해 
        }
        catch(err){
            console.error(err);
            Toast({ isSuccess: false, msg: err });
        }
    }

    // ✅ Discharge 이벤트 (Patient ID가 비어있을 경우에만 동작)
    const handleDischarge = async (deviceId,patientId) => {
        try{
            const payload = {
                status: "UNASSIGNED"
            }

            const res = await axios.patch(`/patient/${patientId}/status`,payload);
            if (res.code != '200') throw res
            
            setAdmittedStatus(deviceId,'discharge','_');
            handleSaveParameter(); //Dashboard에 화면 설정 보여주기 위해 
        }
        catch(err){
            console.error(err);
            Toast({ isSuccess: false, msg: err });
        }
    }

    // ✅ 저장 버튼 클릭 이벤트
    const handleSave = async () => {
        try{
            //현재 연결된 디바이스만 필터링
            const connectedPatients = changeOriginalPatients.filter(
                patient => Array.isArray(globalConnectedDevice) && globalConnectedDevice.includes(patient.deviceId)
            );
            
            //변경된 환자만 추출 (deviceId 기준)
            const changedConnectedPatients = connectedPatients.filter(changed => {
                const original = originalPatients.find(orig => orig.deviceId === changed.deviceId);
                // original이 없거나, 값이 다르면 true
                return !original || !isEqual(changed, original);
            });
            
            // connect 된 환자 중 변경된 환자가 없으면 저장하지 않고 메시지 표시
            if(changedConnectedPatients.length === 0) {
                Toast({ isSuccess: false, msg: t('setting.noChanges')});
                return;
            }

            //변경된 환자 정보로 payload 생성
            const patients = changedConnectedPatients.map(patient => ({
                patientId: patient.id, // 또는 patient.patientId, 데이터 구조에 따라 맞춰주세요
                name: patient.name,
                devicePatientId: patient.devicePatientId,
                gender: patient.gender,
                birthDate: patient.birthDate,
            }));

            const payload = { patients };                        
            const res = await axios.put('/patients', payload);
            if (res.code !== 200) throw res;

            Toast({ isSuccess: true});            
            setIsDisabled(true);            
            await handleSaveParameter();
            setPatientList();
        }catch(error) {
            console.error(error);
            if(error.code == 1000){
                if(error.message.includes('Conflict')) {
                    Toast({ isSuccess: false, msg: t('setting.ErrorConflict') });
                }else{
                    Toast({ isSuccess: false , msg : `Error: ${error}` });
                }
            }else{
                Toast({ isSuccess: false , msg : `Error: ${error}` });        
            }            
        }
    }
    
    // ✅ 변경된 환자 목록이 원본과 다를 때 저장 버튼 활성화
    useEffect(() => {        
        if (!isEqual(changeOriginalPatients, originalPatients)) {
            setIsDisabled(false);
        } else {
            setIsDisabled(true);
        }
    }, [changeOriginalPatients]);

    // ✅ 데이터 조회 (monitor 세팅에서 Device만 설정 가져오기)
    useEffect(() => {    
        if(wardSettings){
            const monitorSetting = Array.isArray(wardSettings)
            ? wardSettings.find(setting => setting.displayOrder === curMonitor)
            : wardSettings;
        
            setDashBoard(monitorSetting);
        }        
    }, [wardSettings])

    // ✅ 현재 Dashboard 세팅 시 환자 목록 조회
    useEffect(() => {
            //최초 Render 시에는 비활성화
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        setPatientList();
    }, [dashboard]) 

    // Gender 드롭다운 외부 클릭 시 닫기
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".gender-dropdown")) {
                setOpenDropdownIndex(null);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [])    

    // useEffect(() => {
    //     console.log('globalConnectedDevice : ', globalConnectedDevice);
    // }, [globalConnectedDevice])

    return (
        <div className="relative w-full h-full">
            <div
                className="overflow-y-auto scrollbar"
                style={{ height: "calc(100%)" }}
            >
                <table className="table-fixed w-full text-[#DEDEDE]">
                    {/* 테이블 헤더 (sticky) */}
                    <thead className="h-[44px] sticky box-border top-0 z-10 p-[8px] text-[14px] leading-[14.5px] border-b border-[#444444]">
                        <tr>
                            <th className={`${thClasses} bg-[#262626] w-[124.5px]`}>{t('setting.ward')}</th>
                            <th className={`${thClasses} bg-[#262626] w-[124.5px]`}>{t('setting.equipment')}</th>
                            <th className={`${thClasses} bg-[#262626] w-[124px] whitespace-nowrap`}>{t('setting.bedNo')}</th>
                            <th className={`${thClasses} bg-[#262626] w-[124px]`}>{t('setting.connection')}</th>
                            <th className={`${thClasses} bg-[#262626] w-[100px]`}>{t('setting.admitted')}</th>
                            <th className={`${thClasses} bg-[#262626] w-[180px]`}>{t('setting.name')}</th>
                            <th className={`${thClasses} bg-[#262626] w-[180px]`}>{t('setting.patientId')}</th>
                            <th className={`${thClasses} bg-[#262626] w-[124px]`}>{t('setting.gender')}</th>
                            <th className={`${thClasses} bg-[#262626] w-[180px]`}>{t('setting.dateOfBirth')}</th>                            
                            <th className={`${thClasses} bg-[#262626] w-[]`}></th>
                            <th className={`${thClasses} bg-[#262626] w-[]`}></th>
                            <th className={`${thClasses} bg-[#262626] w-[]`}></th>
                            <th className={`${thClasses} bg-[#262626] w-[]`}></th>
                            <th className={`${thClasses} bg-[#262626] w-[]`}></th>
                        </tr>
                    </thead>

                    {/* 데이터 영역 */}
                    <tbody>
                        {
                            changeOriginalPatients.map((patient, index) => 
                            {   
                                const isConnected = (Array.isArray(globalConnectedDevice) ? globalConnectedDevice : []).includes(patient.deviceId);
                                const isModify = deviceModelMenus.find(item => item.model === patient.deviceModel)?.patientInfoModify;                                
                                
                                return (
                                    <tr
                                        key={index}
                                        className={` ${
                                            index % 2 === 0
                                                ? "bg-[#2F2F2F]"
                                                : "bg-[#343434]"
                                        }`}
                                    >
                                        <td className={`${tdClasses} text-left`}>                  
                                            <div
                                                className="truncate"
                                                style={{                                                
                                                    display: 'block',
                                                }}
                                                title={curWard.label}
                                            >
                                                {curWard.label}
                                            </div>
                                        </td>
                                        <td className={`${tdClasses} text-left`}>{patient.deviceModel}</td>
                                        <td className={`${tdClasses} text-left`}>                  
                                            {/* {`BED-${pad(patient.bedNumber, 2)}`} */}
                                            {patient.bedNumber != null ? `BED-${String(patient.bedNumber).padStart(2, '0')}` : ''}
                                        </td>
                                        <td className={`${tdClasses}`}>
                                             {isConnected ? <IconConnected className="inline-block" /> : <IconDisConnected className="inline-block" />}
                                        </td>
                                        <td className={`${tdClasses} text-center`}>
                                            {
                                                patient.status == 'ADMITTED' ? (
                                                    <IconCheck className="w-4 h-4 inline-block" />                                                    
                                                ) : (
                                                    <button 
                                                        className={`w-full flex items-center justify-center my-[2px] h-[26px] px-[8px] py-[7px] gap-[8px] rounded-[6px] 
                                                            ${isConnected ? ' text-white border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200' : 'bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'} 
                                                            text-center font-pretendard text-[16px] font-light`}
                                                        onClick={() => {isConnected && handleAdmitConfirm(patient.deviceId);}}
                                                        >{
                                                            t('setting.admit')}
                                                    </button>
                                                )
                                            }

                                        </td>
                                        <td className={`${(!isModify || !isConnected) ? `opacity-10` : ''} ${tdClasses} !p-0`}>                                        
                                            <input
                                                type="text"                                                
                                                className={`bg-transparent w-full h-[30px] p-[8px] box-border border border-transparent`}
                                                disabled={(!isModify || !isConnected)}
                                                value={patient.name || ''}
                                                maxLength={40}
                                                onChange={(e) => {
                                                    const filteredValue = e.target.value.replace(/[^a-zA-Z0-9\s!@#$%^&*()_-]/g, '');
                                                    const value = filteredValue.slice(0, 40); // 40자 제한
                                                    handleChangeValue(patient.deviceId,'name',value);
                                                }}                                                
                                            />
                                        </td>
                                        <td className={`${(!isModify || !isConnected) ? `opacity-10` : ''} ${tdClasses} !p-0`}>
                                            <input
                                                type="text"
                                                className="bg-transparent w-full h-[30px] p-[8px] box-border border border-transparent"
                                                value={patient.devicePatientId || ''}
                                                disabled={(!isModify || !isConnected)}
                                                maxLength={40}
                                                onChange={(e) => {
                                                    const filteredValue = e.target.value.replace(/[^a-zA-Z0-9\s!@#$%^&*()_-]/g, '');
                                                    const value = filteredValue.slice(0, 40); // 40자 제한
                                                    handleChangeValue(patient.deviceId,'devicePatientId',value);
                                                }}
                                                onFocus={
                                                    (e) => {
                                                        setTempPatientId(e.target.value);
                                                    }
                                                }
                                                onBlur={
                                                    (e) => {
                                                        const value = e.target.value.replace(/ /gi, "");
                                                        if(_.isEmpty(value) && patient.status == 'ADMITTED'){
                                                            if(isConnected){
                                                                handleDischargeConfirm(patient.deviceId,patient.id, patient.name);
                                                            }                                                           
                                                        }
                                                    }
                                                }
                                            />
                                        </td>

                                        <td className={`${(!isModify || !isConnected) ? `opacity-10` : ''} ${tdClasses} pl-[4px] pr-[8px]`}>                                        
                                            <div className="relative gender-dropdown">
                                                <div
                                                    className={`${isModify && isConnected ? 'cursor-pointer' : ''} bg-transparent text-white w-full h-[30px] flex items-center justify-between`}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if(isModify && isConnected){
                                                            toggleDropdown(index);
                                                        }
                                                    }}
                                                >
                                                    <div className="w-[108px] text-left">
                                                        {patient.gender === "M" ? t('setting.male') : patient.gender === "F" ? t('setting.female') : t('setting.notSelected')}
                                                    </div>
                                                    <div>
                                                        {openDropdownIndex === index ? (<IconArrowUp />) : (<IconArrowDown />)}
                                                    </div>
                                                </div>
                                                {openDropdownIndex === index && (
                                                    <div className={`absolute left-[-5px] bg-[#1F1F1F] w-[124px] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20 ${changeOriginalPatients.length > 10 && index >= changeOriginalPatients.length - 3 ? 'bottom-[30px]' : ''}`}>
                                                        <div className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] ${patient.gender === "M" ? "text-[#3182F7]" : "text-white"}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleChangeValue(patient.deviceId,'gender','M');
                                                                toggleDropdown(index);
                                                            }}
                                                        >
                                                        {t('setting.male')}
                                                        {patient.gender === "M" && ( <IconCheckBlue className="w-4 h-4 ml-2" /> )}
                                                        </div>
                                                        <div
                                                            className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] ${patient.gender === "F" ? "text-[#3182F7]": "text-white"}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleChangeValue(patient.deviceId,'gender','F');
                                                                toggleDropdown(index);
                                                            }}
                                                        >
                                                        {t('setting.female')}
                                                        {patient.gender === "F" && ( <IconCheckBlue className="w-4 h-4 ml-2" />)}
                                                        </div>
                                                        <div
                                                            className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] ${patient.gender === "N" ? "text-[#3182F7]": "text-white"}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleChangeValue(patient.deviceId,'gender','N');
                                                                toggleDropdown(index);
                                                            }}
                                                        >
                                                        {t('setting.notSelected')}
                                                        {patient.gender === "N" && ( <IconCheckBlue className="w-4 h-4 ml-2" />)}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>                                        
                                        </td>                                    
                                        <td className={`${(!isModify || !isConnected) ? `opacity-10` : ''} ${tdClasses} !p-0`}>                                        
                                            <input
                                                type="text"
                                                className="bg-transparent w-full h-[30px] p-[8px] box-border border border-transparent"
                                                placeholder={`${isModify && isConnected ? 'YYYY-MM-DD' : ''}`}
                                                disabled={(!isModify || !isConnected)}
                                                value={patient.birthDate || ''}
                                                maxLength={8}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^0-9]/g, '');                                                
                                                    handleChangeValue(patient.deviceId,'birthDate',value);
                                                }}
                                                onFocus={(e) => {
                                                    // let rawValue = e.target.value.replace(/[^0-9]/g, '');
                                                    // rawValue = rawValue != '' ? rawValue : null;
                                                    // handleChangeValue(patient.id,'birthDate',rawValue);
                                                    const value = e.target.value.replace(/[^0-9]/g, '');
                                                    handleChangeValue(patient.deviceId, 'birthDate', value);
                                                }}
                                                onBlur={(e) => {
                                                    const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                                    if (rawValue.length === 8) {
                                                        const year = parseInt(rawValue.slice(0, 4), 10);
                                                        const month = parseInt(rawValue.slice(4, 6), 10);
                                                        const day = parseInt(rawValue.slice(6, 8), 10);

                                                        // 날짜 유효성 검사
                                                        const date = new Date(year, month - 1, day); // 월은 0부터 시작
                                                        if (
                                                            date.getFullYear() === year &&
                                                            date.getMonth() === month - 1 &&
                                                            date.getDate() === day
                                                        ) {
                                                            // 올바른 날짜 형식으로 반영
                                                            const formattedValue = `${year.toString().padStart(4, '0')}-${month
                                                                .toString()
                                                                .padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
                                                            handleChangeValue(patient.deviceId,'birthDate',formattedValue);
                                                            return;
                                                        }
                                                    }
                                                    // 유효하지 않은 날짜는 빈 값으로 처리
                                                    handleChangeValue(patient.deviceId,'birthDate',null);
                                                }}
                                            />                                        
                                        </td>
                                        <td className={`${tdClasses}`}></td>
                                        <td className={`${tdClasses}`}></td>
                                        <td className={`${tdClasses}`}></td>
                                        <td className={`${tdClasses}`}></td>
                                        <td className={`${tdClasses}`}></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>                    
                </table>
            </div>
            <button
                className={`w-[88px] h-[28px] absolute top-[-35px] right-[20px] rounded-[6px] 
                    ${
                        isDisabled
                        ? "bg-[#1f1f1f] text-[rgba(255,255,255,0.2)] cursor-default shadow-none"
                        : "text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200"
                    }
                    active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                disabled={isDisabled}
                onClick={handleSave}
            >
                {isDisabled ? t('setting.saved') : t('setting.save')}
            </button>
        </div>
    );
};

export default PatientInfoSettings;
